<template>
  <el-menu :default-active="activeKey" class="el-menu-vertical-demo layout-menu" :collapse="props.isCollapse"
    @open="handleOpen" @close="handleClose" :unique-opened="true">
    <el-menu-item index="1" @click="gotohome">
      <el-icon>
        <component is="menu"></component>
      </el-icon>
      <template #title>首页</template>
    </el-menu-item>
    <el-sub-menu :index="item.index" :key="item.index" v-for="(item, index) in menuList">
      <template #title>
        <el-icon>
          <component :is="item.icon"></component>
        </el-icon>
        <span>{{ item.name }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item @click="selectItem(item, child)" :index="child.index" :key="child.path"
          v-for="(child, cIndex) in item.children"><el-icon>
            <ArrowRight />
          </el-icon>{{ child.name }}</el-menu-item>
      </el-menu-item-group>
    </el-sub-menu>
  </el-menu>
</template>

<script setup>
import store from "@/store";
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router/dist/vue-router";
const menuList = ref([
  {
    name: "用户管理",
    index: "1",
    path: "/",
    icon: "User",
    children: [
      {
        name: "用户列表",
        index: "1-1",
        path: "/userList",
      },
      // {
      //   name: "用户登录记录",
      //   index: "13-13",
      //   path: "/userLoginLog",
      // },
    ],
  },

  {
    name: "抽奖管理",
    index: "12",
    path: "/",
    icon: "GoldMedal",
    children: [
      // {
      //   name: "集字列表",
      //   index: "12-8",
      //   path: "/collectWords",
      // },
      // {
      //   name: "集字记录",
      //   index: "12-10",
      //   path: "/wordsLogLists",
      // },
      // {
      //   name: "大奖设置",
      //   index: "12-9",
      //   path: "/bigRaffleLists",
      // },
      // {
      //   name: "大奖记录",
      //   index: "12-11",
      //   path: "/bigRaffleLogLists",
      // },
      {
        name: "幸运抽奖",
        index: "12-3",
        path: "/lottory",
      },
      {
        name: "抽奖记录",
        index: "12-4",
        path: "/lottoryDetails",
      },
      {
        name: "开奖时间设置",
        index: "12-5",
        path: "/lotteryTimeSettings",
      },
    ],
  },


  {
    name: "运营管理",
    index: "4",
    path: "/",
    icon: "Pointer",
    children: [
      {
        name: "轮播图",

        index: "4-15",

        path: "/bannerList",
      },

      {
        name: "文章类型",
        index: "4-10",
        path: "/newsTypeList",
      },

      {
        name: "文章资讯",
        index: "4-1",
        path: "/newsList",
      },

      // {
      //     name: '站内信',
      //     index: '4-5',
      //     path: '/letters'
      // },

      {
        name: "用户反馈",
        index: "4-9",
        path: "/userFeedback",
      },
    ],
  },
  {
    name: "系统设置",
    index: "5",
    path: "/",
    icon: "Setting",
    children: [
      {
        name: "谷歌密钥",
        index: "5-4",
        path: "/googleKeys",
      },
    ],
  },
  // {
  //     name: '视频管理',
  //     index: '6',
  //     path: '/',
  //     icon: 'Film',
  //     children: [
  // {
  //     name: '视频分类',
  //     index: '6-1',
  //     path: '/videoType'
  // },{
  //     name: '视频管理',
  //     index: '6-2',
  //     path: '/videoList'
  // },
  //         {
  //             name: '宣传视频',
  //             index: '6-3',
  //             path: '/xuanchuanVideo'
  //         }
  //     ]
  // },
  {
    name: "后台管理",
    index: "7",
    path: "/",
    icon: "Guide",
    children: [
      {
        name: "后台用户",
        index: "7-1",
        path: "/backendUser",
      },
      {
        name: "登录日志",
        index: "7-2",
        path: "/loginLog",
      },
    ],
  },
]);

const router = useRouter();
const selectItem = (item, child) => {
  // const selectItem
  let arr = [
    {
      name: "首页",
      index: "1",
      path: "/home",
    },
    item,
    child,
  ];
  store.commit("updateBreakCum", arr);
  router.push(child.path);
};

const activeKey = ref("1");
const route = useRoute();

watch(
  () => route.path,
  (newPath, oldPath) => {
    menuList.value.map((item) => {
      let res = item.children.filter((_t) => _t.path === newPath);
      if (res.length > 0) {
        activeKey.value = res[0].index;
      }
    });
  },
  { immediate: true }
);

const gotohome = () => {
  let arr = [
    {
      name: "首页",
      index: "1",
      path: "/home",
    },
  ];
  store.commit("updateBreakCum", arr);
  router.push("/home");
};

const handleOpen = (key, keyPath) => { };
const handleClose = (key, keyPath) => { };

const props = defineProps(["isCollapse"]);
</script>

<style lang="less" scoped>
.layout-menu {
  // width: 220px;
  height: 100%;
  background-color: #eee;
  transition: all 0.25s;
  overflow-y: auto;
}
</style>
